import { render, staticRenderFns } from "./PlaneacionesView.vue?vue&type=template&id=ab72855c&"
import script from "./PlaneacionesView.vue?vue&type=script&lang=js&"
export * from "./PlaneacionesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports